export default __webpack_public_path__ + "static/media/spot.64462942.svg";